import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bw_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? JSON.stringify(e)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};

export const api = {
  createBooking: (data) => axios.post(`${API}/bookings`, data),
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeaders() }),
  listBookings: () => axios.get(`${API}/bookings`, { headers: authHeaders() }),
  updateBooking: (id, data) => axios.patch(`${API}/bookings/${id}`, data, { headers: authHeaders() }),
  deleteBooking: (id) => axios.delete(`${API}/bookings/${id}`, { headers: authHeaders() }),
};
